import { fetch } from "../fetch";
import axios from "axios";

export const fetchGetCaptcha = async (payload: any) =>
  fetch(
    `${process.env.MS_LOGIN}/getCaptcha`,
    axios.post,
    JSON.stringify(payload),
    {
      headers: {
        "Content-Type": "application-bribrain/json",
        // 'ngrok-skip-browser-warning': 'true'

      },
    }
  );
export const fetchDoLogin = async (payload: any) =>
  fetch(
    `${process.env.MS_LOGIN}/login`,
    axios.post,
    JSON.stringify(payload),
    // payload,
    {
      headers: {
        "Content-Type": "application-bribrain/json",
        // 'ngrok-skip-browser-warning': 'true'
      },
    });

export const fetchDoLoginSingleProduct = async (payload: any, token: any) =>
  fetch(
    `${process.env.MS_LOGIN}/auth/product/${payload}`,
    axios.post,
    {},
    {
      headers: {
        "Content-Type": "application-bribrain/json",
        // 'ngrok-skip-browser-warning': 'true',
        Authorization: token,

      },
    });

export const fetchDoLogout = async (payload: any, token: any) =>
  fetch(
    `${process.env.MS_LOGIN}/auth/logout`,
    axios.post,
    JSON.stringify(payload),
    {
      headers: {
        "Content-Type": "application-bribrain/json",
        Authorization: `${token}`,
      },
    }
  );

export const fetchValidateTokenBSS = async (payload: any) =>
  fetch(
    `${process.env.MS_LOGIN}/login-bss`,
    axios.post,
    JSON.stringify(payload),
    {
      headers: {
        "Content-Type": "application-bribrain/json",
      },
    }
  );

export const fetchMenuList = async (token: any) =>
  fetch(
    `${process.env.MS_LOGIN}/auth/list-product`,
    axios.post,
    {},
    {
      headers: {
        "Content-Type": "application-bribrain/json",
        Authorization: token,
      },
    }
  );

export const fetchValidateTokenBRISPOT = async (payload: any) =>
  fetch(
    `${process.env.MS_LOGIN}/validateTokenBRISpot`,
    axios.post,
    {},
    {
      headers: {
        "Content-Type": "application-bribrain/json",
        Authorization: payload.key,
      },
    }
  );

export const fetchListWordStyling = async () =>
  fetch(
    `${process.env.MS_BRIBRAIN_MAIN}/list-word-styling`,
    axios.post,
    {},
    {
      headers: {
        "Content-Type": "application-bribrain/json",
        "x-api-key": `${process.env.X_API_KEY}`,
      },
    }
  );

export const fetchHeadline = async () =>
  fetch(
    `${process.env.MS_BRIBRAIN_MAIN}/headline`,
    axios.post,
    {},
    {
      headers: {
        "Content-Type": "application-bribrain/json",
        "x-api-key": `${process.env.X_API_KEY}`,
      },
    }
  );

export const fetchListServices = async () =>
  fetch(
    `${process.env.MS_BRIBRAIN_MAIN}/list-layanan-utama`,
    axios.post,
    {},
    {
      headers: {
        "Content-Type": "application-bribrain/json",
        "x-api-key": `${process.env.X_API_KEY}`,
      },
    }
  );

export const fetchListProduk = async () =>
  fetch(
    `${process.env.MS_BRIBRAIN_MAIN}/list-daftar-produk`,
    axios.post,
    {},
    {
      headers: {
        "Content-Type": "application-bribrain/json",
        "x-api-key": `${process.env.X_API_KEY}`,
      },
    }
  );

export const fetchCallToAction = async () =>
  fetch(
    `${process.env.MS_BRIBRAIN_MAIN}/call-to-action`,
    axios.post,
    {},
    {
      headers: {
        "Content-Type": "application-bribrain/json",
        "x-api-key": `${process.env.X_API_KEY}`,
      },
    }
  );
